// extracted by mini-css-extract-plugin
export default {"graph__container":"DoughnutGrade_graph__container__cd3o5","graph__text":"DoughnutGrade_graph__text__G6xco"};